import { Store } from '@tanstack/store';

interface AuthStoreState {
  isLogin: boolean;
  isAdmin: boolean;
  isInitialized: boolean;
}

export const AuthStore = new Store<AuthStoreState>({
  isLogin: false,
  isAdmin: false,
  isInitialized: false,
});
